/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_UploadInputs */

const cs_documents_upload = /** @type {(inputs: Documents_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát`)
};

const en_documents_upload = /** @type {(inputs: Documents_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload`)
};

/**
* | output |
* | --- |
* | "Upload" |
*
* @param {Documents_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_upload = /** @type {((inputs?: Documents_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_upload(inputs)
	return cs_documents_upload(inputs)
});